import { oc } from '@orpc/contract';
import { listValidityRulesInputSchema, listValidityRulesOutputSchema } from '../schemas/config.schemas.js';
export const listValidityRulesContract = oc
    .route({
    method: 'GET',
    path: '/config/validity-rules',
    tags: ['Config'],
    summary: 'List the validity rules every submitted run is judged against',
})
    .input(listValidityRulesInputSchema)
    .output(listValidityRulesOutputSchema);
//# sourceMappingURL=list-validity-rules.contract.js.map